import React, { useEffect } from 'react'

export type WithPlannerProps = {
  planner?: {
    timeout(f: () => void, t: number): NodeJS.Timeout
    interval(f: () => void, t: number): NodeJS.Timeout
    clearTimeouts(t?: NodeJS.Timeout[]): boolean
    clearIntervals(i?: NodeJS.Timeout[]): boolean
  }
}

export const withPlanner = <P extends WithPlannerProps>(Child: React.FC<P>): React.FC<P> => {
  return ({ ...props }): JSX.Element => {
    const timeouts: NodeJS.Timeout[] = []
    const intervals: NodeJS.Timeout[] = []

    useEffect(() => {
      return () => {
        timeouts.map((i) => clearTimeout(i))
        intervals.map((i) => clearInterval(i))
      }
    }, [])

    const planner = {
      timeout: (f: () => void, t: number): NodeJS.Timeout => {
        const id = setTimeout(f, t)
        timeouts.push(id)
        return id
      },
      clearTimeouts: (t?: NodeJS.Timeout[]) => {
        if (t) {
          t.map((item) => clearTimeout(item))
          return true
        }
        timeouts.map((item) => clearTimeout(item))
        return true
      },

      interval: (f: () => void, t: number): NodeJS.Timeout => {
        const id = setInterval(f, t)
        intervals.push(id)
        return id
      },
      clearIntervals: (i?: NodeJS.Timeout[]) => {
        if (i) {
          i.map((item) => clearInterval(item))
          return true
        }
        intervals.map((item) => clearInterval(item))
        return true
      },
    }

    return <Child {...props} planner={planner} />
  }
}
